<template>
  <section class="vbox">    
    <section class="scrollable wrapper">
      <div class="content-header">
        <el-breadcrumb separator="/">
          <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
          <el-breadcrumb-item><a href="/">店铺</a></el-breadcrumb-item>
          <el-breadcrumb-item>店铺信息</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
      <el-form ref="form" v-model="chainStore" label-width="160px" size="medium">
        <el-form-item label="店铺名称">
          <el-col :span="11">
            <el-input v-model="chainStore.name" ></el-input>
          </el-col>
        </el-form-item>        
        <el-form-item label="所属商家">
          <el-col :span="11">
            <el-input v-model="merchantName" readonly placeholder="名称">
              <el-button  slot="append" icon="el-icon-search" @click="selectMerchantHandle"></el-button>
            </el-input>   
          </el-col>
        </el-form-item> 
        <el-form-item label="所属行业">
          <el-select v-model="chainStore.industryId" placeholder="请选择行业">
            <el-option
              v-for="item in industrys"
              :key="item.id"
              :label="item.name"
              :value="item.id">
            </el-option>
          </el-select>          
        </el-form-item>
        <el-form-item label="人均消费">
          <el-col :span="11">
            <el-input v-model="chainStore.perCapitaConsumeAmount" >       
              <el-button slot="append" >元</el-button>
            </el-input>
          </el-col>
        </el-form-item>
        <el-form-item label="线上显示">
          <el-col :span="11">
            <el-switch
              v-model="chainStore.viewOnLine">
            </el-switch>
          </el-col>
        </el-form-item>
        <el-form-item label="支持外送">
          <el-col :span="11">
            <el-switch
              v-model="chainStore.isTakeOut">
            </el-switch>
          </el-col>
        </el-form-item>
        <el-form-item label="今日推介">
          <el-col :span="11">
            <el-switch
              v-model="chainStore.recommend">
            </el-switch>
          </el-col>
        </el-form-item>
        <el-form-item label="排序">
          <el-col :span="11">
            <el-input v-model="chainStore.sort" ></el-input>
          </el-col>
        </el-form-item>
        <el-form-item label="联系电话">
          <el-col :span="11">
            <el-input v-model="chainStore.mobile"></el-input>
          </el-col>
        </el-form-item>
        <el-form-item label="Icon图标">
          <el-col :span="11">
            <el-upload
              class="icon-uploader"
              :action="uploadUrl"
              :headers="headers"
              :show-file-list="false"
              :on-success="handleIconSuccess"
              :before-upload="beforeIconUpload">
              <img v-if="chainStore.icon" :src="chainStore.icon" class="icon">
              <i v-else class="el-icon-plus icon-uploader-icon"></i>
              <div slot="tip" class="el-upload__tip">请上传1:1大小的图标(如100px*100px)</div>
            </el-upload>
          </el-col>
        </el-form-item>
        <el-form-item label="店铺形象图片">
          <el-col :span="20">
            <el-upload             
              :action="uploadUrl"
              multiple
              :limit="4"
              :file-list="imagesList"
              :headers="headers"
              list-type="picture-card"
              :on-preview="handlePictureCardPreview"
              :on-success="handlePictureCardSuccess"
              :on-remove="handleRemove">
              <i class="el-icon-plus"></i>
              <div slot="tip" class="el-upload__tip">请上传1.6:1大小的图片(如160px*100px)可上传4张</div>
            </el-upload>
          </el-col>
        </el-form-item>
        <!-- <el-form-item label="客服工号">
          <el-col :span="11">
            <el-input v-model="chainStore.customerServiceAccount"></el-input>
          </el-col>
        </el-form-item> -->
        <el-form-item label="地址">
          <el-col :span="11">
            <el-input v-model="chainStore.address" >
            </el-input>
          </el-col>
        </el-form-item>        
        <el-form-item label="坐标">
          <el-col :span="4" inline>
            <el-input v-model="chainStore.lng" placeholder="输入经度坐标" >
            </el-input>
          </el-col>          
          <el-col class="line" :span="1">——</el-col>
          <el-col :span="6" inline>
            <el-input v-model="chainStore.lat" placeholder="输入纬度坐标" >
              <el-button slot="append" icon="el-icon-location-information" @click="ShowMap"></el-button>
            </el-input>
          </el-col>
        </el-form-item>
        <el-form-item label="标签">
          <el-col :span="11">
            <el-input v-model="chainStore.label" >
            </el-input>
          </el-col>
        </el-form-item>  
        <el-form-item label="分享描述">
          <el-col :span="11">
            <el-input type="textarea" v-model="chainStore.shareDescription"></el-input>
          </el-col>
        </el-form-item>
        <el-form-item label="描述">
          <editor @showEditor="updateDescription" :content="chainStore.description"></editor>
        </el-form-item>
        <el-form-item >
          <el-col :span="11">
            <el-button type="primary" @click="SaveChainStore">保 存</el-button>            
            <el-button style="margin-left: 8px" @click="handleBack">返回列表</el-button>
          </el-col>
        </el-form-item>
      </el-form>
    </section>    
    <GetCoordinate v-bind:dialogMap="dialogMap" @UpdatePostion="UpdatePostion"></GetCoordinate>
    <GetMerchant v-bind:dialogMerchant="dialogMerchant" @UpdateMerchant="UpdateMerchant"></GetMerchant> 
  </section>
</template>
<script  type='text/ecmascript-6'>
  import GetCoordinate from '@/components/GetCoordinate'
  import editor from '@/components/wang-editor'
  import GetMerchant from '@/components/GetMerchant'
  export default {
    props:{
    },
    components:{    
      editor,
      GetCoordinate,
      GetMerchant
    },
    data (){
      return {
        chainStore:{},
        uploadUrl: this.global.serverSrc+'/api/Common/UploadImage',
        headers:{
          Authorization : sessionStorage.getItem('token')
        },
        businesses:[],
        industrys:[],
        dialogMap:{
          isShow:false,
          oldPoint:{
            lat:0,
            lng:0
          }
        },
        dialogMerchant:{
          isShow:false
        },
        merchantName:''
      }
    },
    computed:{
      imagesList:function(){
        var result= [];
        if(this.chainStore.images!=undefined){
          var images = this.chainStore.images.split(',');
          images.forEach(element => {            
            let o=  {
              url:element
            }
            //o.url=element
            result.push(o)
          });
        }        
        return result;
      }
    },
    mounted(){
      var that = this
      this.axios({
        method:'get',
        url:that.global.serverSrc + '/api/ChainStore/Get',         
        params:{
          id:that.$route.params.Id
        }
      }).then(function (resp) {
        that.chainStore = resp.data.chainStore
        that.merchantName = resp.data.merchantName
        that.industrys = resp.data.industrys        
        that.dialogMap.oldPoint.lat=that.chainStore.lat
        that.dialogMap.oldPoint.lng=that.chainStore.lng      
      })
      
    },
    methods:{     
      SaveChainStore:function(){
        var that = this
        this.axios({
          method:'post',
          url:that.global.serverSrc + '/api/ChainStore/Save',         
          data:that.chainStore
        }).then(function (resp) {
          if(resp.data.errorCode==0){
            that.$message.success(resp.data.message);
          }else {
            that.$message.warning(resp.data.message);
          }  
        }).catch(resp => {         
          console.log('请求失败：' + resp.message + ',' + resp.stack)
        })
      },
      handleIconSuccess(resp, file){
        if(resp.success){
          this.chainStore.icon= resp.fullUrl
        }else{
          this.$message.warning(resp.message);
        }
        //this.imageUrl = URL.createObjectURL(file.raw);
      },
      beforeIconUpload(file){
        const isLt2M = file.size / 1024 / 1024 < 2;        
        if (!isLt2M) {
          this.$message.error('上传头像图片大小不能超过 2MB!');
        }
        return isLt2M;
      },
      handleRemove(file, fileList) {
        console.log(file, fileList);
      },
      handlePictureCardPreview(file) {
        this.dialogImageUrl = file.url;
        this.dialogVisible = true;
      },
      handlePictureCardSuccess(res,file,fileList){
        debugger
        if(this.chainStore.images==undefined){
          this.chainStore.images = res.fullUrl
        }else{
          this.chainStore.images += ',' + res.fullUrl;
        }
      },
      updateDescription(data){
        this.chainStore.description=data
      },
      ShowMap(){
        // this.dialogMap.isShow = true
        window.open('https://api.map.baidu.com/lbsapi/getpoint/index.html')
      },
      UpdatePostion:function(point){
        this.chainStore.lat = point.lat
        this.chainStore.lng = point.lng
      },
      selectMerchantHandle:function(){
        this.dialogMerchant.isShow = true
      },
      UpdateMerchant(id,name){
        this.merchantName = name
        this.chainStore.merchantId = id
      },
      handleBack(){
        var that = this
        this.$confirm('请先确定已经保存内容！', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          that.$router.push({
            name: 'chainStore',
            params: {
              queryParam: that.$route.params.queryParam
            }
          })
        }).catch(() => {
            
        });
      }
    },
    created(){
    
    },
  }
</script>
<style lang='stylus' rel='stylesheet/stylus'>
  .content-header
    padding 24px
    border 1px solid #C0C4CC
    margin-bottom 24px
  .icon-uploader
    .el-upload
      border 1px dashed #d9d9d9
      border-radius 6px
      cursor pointer
      position relative
      overflow hidden
      .el-upload
      &:hover
        border-color #409EFF
      img
        width 100px
        height 100px
  .icon-uploader-icon
    font-size 28px
    color #8c939d
    width 100px
    height 100px
    line-height 100px
    text-align center  
  .map
    width: 100%;
    height: 300px;
   .el-upload-list__item-thumbnail 
      object-fit: contain;
</style>